import {
  Grid,
  Paper,
  TableContainer,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import CustomButton from "../../../Components/CustomButton";
import LeftSideNav from "../../../Components/LeftSideNav";
import Loader from "../../../Components/Loader";
import TopNavBar from "../../../Components/TopNavbar";
import Fonts from "../../../Config/Fonts";
import Strings from "../../../Config/Strings";
import { updateProductCategoryDetailsAPI } from "../../../Store/Action/productCategory";
import Colors from "../../../theme/Colors";

const UpdateProductCategory = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { editProdCategory } = location?.state || {};
  const [loading, setLoading] = useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/", text: "Home" },
      { key: "2", href: "/userList", text: "Masters" },
      { key: "3", href: "/productCategory", text: "Product Category" },
      {
        key: "4",
        href: `/productCategory/edit", text: "Update Product Category"`,
      },
    ]);
  }, []);

  if (!editProdCategory) {
    return <div>No product Category details available.</div>;
  }

  const onSubmit = async (data) => {
    const updateProductCategoryData = {
      product_category_id: editProdCategory?.product_category_id,
      product_category_name: data?.CategoryName,
    };
    setLoading(true);
    try {
      await dispatch(
        updateProductCategoryDetailsAPI(
          updateProductCategoryData,
          (isSuccess, response) => {
            setLoading(false);
            if (isSuccess?.status === true) {
              toast.success("Product Category Updated Successfully");
              navigate("/productCategory");
            } else {
              const errorMessage =
                response?.error?.message || Strings.somethingWentWrongError;
              toast.error(errorMessage);
            }
          }
        )
      );
    } catch (error) {
      console.log("Error dispatching addProducts:", error);
      setLoading(false);
      toast.error(Strings.somethingWentWrongError);
    }
  };
  return (
    <div style={mainContainer}>
      <LeftSideNav />

      <div style={leftNavContainer}>
        <div style={topBar}>
          <TopNavBar />

          <div style={pageTitle}>
            <h2>Product Category</h2>
          </div>

          <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
        </div>

        <TableContainer component={Paper} style={tableContainer}>
          <p style={mainHeadingStyle}>Update Product Category</p>

          <hr />

          <form onSubmit={handleSubmit(onSubmit)} style={formStyle}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>Category Name</Typography>
                <Controller
                  name="CategoryName"
                  control={control}
                  defaultValue={editProdCategory.product_category_name}
                  rules={{ required: Strings.productNameRequired }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Enter Category name"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.CategoryName}
                      helperText={
                        errors?.CategoryName ? errors?.CategoryName.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle, // Set background color
                      }}
                    />
                  )}
                />
              </Grid>

              <CustomButton handleSubmit={handleSubmit} label={Strings.Save} />
            </Grid>
          </form>
        </TableContainer>
      </div>

      <Loader loading={loading} />
    </div>
  );
};

const mainContainer = {
  display: "grid",
  gridTemplateColumns: "20% 80%",
  height: "100vh",
  width: "100vw",
  overflowX: "hidden",
  overflowY: "hidden",
};

const leftNavContainer = {
  display: "grid",
  gridTemplateRows: "15% 80%",
  backgroundColor: "#F0F5FF",
};

const topBar = {
  backgroundColor: "white",
  height: "7vh",
  width: "100%",
};

const pageTitle = {
  marginLeft: "30px",
  justifyContent: "flex-start",
  display: "flex",
};

const tableContainer = {
  width: "70vw",
  border: "1px solid #ccc",
  borderRadius: "15px",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  marginTop: "40px",
  paddingLeft: "20px",
  paddingRight: "20px",
  marginLeft: "30px",
};

const formStyle = {
  padding: "20px",
};

const mainHeadingStyle = {
  fontSize: 16,
  fontWeight: "700",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.black,
  display: "flex",
  marginTop: "20px",
  marginBottom: "20px",
};

const labelInfoStyle = {
  fontSize: 14,
  fontWeight: "400",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.black,
  display: "flex",
  marginBottom: "5px",
};

const inputTextStyle = {
  fontSize: 14,
  fontWeight: "400",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.darkGray,
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
  backgroundColor: Colors.lightBlue,
};

export default UpdateProductCategory;
